/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Subtract16 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g className="Subtract 16">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M14 8a1 1 0 0 1-1 1H3a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
const Subtract24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Subtract 24">
      <path
        fill="#0E0E0E"
        d="M1 12a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z"
        className="SVG"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Subtract16,
  md: Subtract24,
  lg: Subtract24,
  xl: Subtract24,
  xxl: Subtract24,
  xxxl: Subtract24,
};

export const SubtractIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'subtract-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
